import { Mechanics } from "game-common/mechanics/mechanics"
import { Entity } from "game-common/models"
import { floorFallZIndex } from "./effects/floor_fall"
import type { ClientRenderable } from "./entity_rendering_manager"
import type { TileMapMetaProvider } from "game-common/tile_map_meta_provider"

export function initializeEntityDepth(entity: Entity, sprite: ClientRenderable, provider?: TileMapMetaProvider): void {
    if (entity.npcType !== "marker" || !entity.spriteId) return
    const offset = provider?.resolveTileMeta(entity.spriteId)?.renderZIdxOffset
    if (offset !== undefined) sprite.defaultZIndex = offset
    sprite.zIndex = entityDepth(entity, sprite.defaultZIndex)
}

/** Shared by active-room bodies and the projected bodies on other floors. */
export const entityDepth = (entity: Entity, defaultZIndex = 0): number => {
    const flat = Mechanics.entity.body.isFlat(entity) || entity.downed ||
        entity.floorFall?.phase === "landed" || entity.rescuePose === "downed"
    const depth = flat ? 0 : Mechanics.entity.body.calculateZIndexBoost(entity) + defaultZIndex || 0
    return floorFallZIndex(entity, depth)
}
